<wbo-edit-page [title]="(model.data.firstName ? model.data.firstName + ' ' : '') + (model.data.lastName || '')" #editPage>
    <fui-formation-group-template *formationGroup="{title: 'wbo.contact.edit.formation.contact', formControlNames: ''}">
        <wbo-contact-edit [formGroupContact]="editPage.formGroup" [contact]="model.data"></wbo-contact-edit>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.contact.edit.formation.account', formControlNames: 'accountPins'}">
        <wbo-contact-edit-accounts></wbo-contact-edit-accounts>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.contact.edit.formation.deliveryTakeaway', formControlNames: ['deliveryContact', 'sendSmsOnTakeawayReady', 'deliveryInstructions', 'customerNotes']}">
        <wbo-contact-edit-delivery-takeaway></wbo-contact-edit-delivery-takeaway>
    </fui-formation-group-template>
</wbo-edit-page>
